import { fg } from '@atlaskit/platform-feature-flags';

// https://switcheroo.atlassian.com/ui/gates/rovo_fps_servicenow_project_renderer
export default {
	get(): boolean {
		return fg('rovo_fps_servicenow_project_renderer');
	},
};
